import globalState from "../lib/global/modules/state";
import globalCache from "../lib/global/modules/cache";
import pCloudIntl, { __ } from "../lib/global/modules/pCloudIntl";
import i18n from "../lib/global/modules/i18n";
import FileSelection from "../lib/global/modules/FileSelection";
import message from "../lib/global/modules/message";
import data from "../lib/global/modules/data";
import user from "../lib/global/modules/user";
import project from "../lib/global/modules/project";
import navigationManager from "../lib/navigationManager";

self.pCloudIntl = pCloudIntl;
self.__ = __;
self.i18n = i18n;
self.globalState = globalState;
self.globalCache = globalCache;
self.FileSelection = FileSelection;
self.globalMessage = message;
self.globalData = data;
self.globalUser = user;
self.globalProject = project;
self.globalNavigationManager = navigationManager;

self.collaborationFileTypes = new Set();
self.currentFolder = 0;
self.LABEL = "REPLACETHISWITHLABEL";
self.DEBUG = "REPLACETHISTHISISDEBUG";
self.CDN = "/ZCDNURL";
if (!self.DEBUG) {
  console.log = function() {};
}
self.PAYMENT_DEBUG = "REPLACETHISTHISISDEBUG";
self.paypalHost = PAYMENT_DEBUG ? "sandbox.paypal.com" : "www.paypal.com";
self.xhrRequest = null;
